<template>
  <div class="finebi-container">
    <iframe
      ref="finebiFrame"
      class="finebi-iframe"
      :src="finebiUrl"
      frameborder="0"
      allowfullscreen
    ></iframe>
    <div v-if="loading" class="loading">加载中...</div>
    <div v-if="error" class="error">加载失败，<button @click="reload">重试</button></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      baseUrl: 'https://finebi.randforest.cn/webroot/decision/link/6mxG',
      finebiUrl: '',
      loading: true,
      error: false,
      timeoutTimer: null
    };
  },
  mounted() {
    // 1. 判断移动端+动态拼接链接（核心修正：移除多余逗号）
    const isMobile = /Mobile|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isMobile) {
      this.finebiUrl = `${this.baseUrl}?t=${Date.now()}`;
    } else {
      this.finebiUrl = this.baseUrl;
    }

    // 2. 原有监听逻辑（修正$nextTick包裹，避免DOM未渲染）
    this.$nextTick(() => {
      const frame = this.$refs.finebiFrame;
      frame.addEventListener('load', this.handleLoad);
      frame.addEventListener('error', this.handleError);

      // 超时处理
      this.timeoutTimer = setTimeout(() => {
        this.loading = false;
        this.error = true;
      }, 15000);
    });
  },
  methods: {
    handleLoad() {
      clearTimeout(this.timeoutTimer);
      this.loading = false;
      this.error = false;
    },
    handleError() {
      clearTimeout(this.timeoutTimer);
      this.loading = false;
      this.error = true;
    },
    reload() {
      this.loading = true;
      this.error = false;
      this.$refs.finebiFrame.src = `${this.baseUrl}?t=${Date.now()}&reload=${Date.now()}`;
    }
  },
  beforeUnmount() {
    clearTimeout(this.timeoutTimer);
  }
};
</script>

<style scoped>
.finebi-container {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}
.finebi-iframe {
  width: 100%;
  height: 100%;
  min-width: auto !important;
  border: none;
}
.loading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
}
.error {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
}
</style>